import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { detectPageLoadType } from './utils/pageLifecycle'
import { generateSessionId } from './utils/sessionStorage'
import { initActivityMonitor } from './utils/activityMonitor'
import { debugLog } from './utils/debugLogger'
import { SignalRProvider } from './context/SignalRContext'

// Initialize our page lifecycle and session tracking
detectPageLoadType();
generateSessionId();

// Initialize the activity monitor
const cleanupActivityMonitor = initActivityMonitor();

// Debug logs for deployment troubleshooting
debugLog('Activity monitor initialized');
debugLog('App initializing with base URL:', import.meta.env.BASE_URL);
debugLog('App mode:', import.meta.env.MODE);
debugLog('App environment:', import.meta.env);

// Cleanup when the app is unmounted
window.addEventListener('beforeunload', () => {
  cleanupActivityMonitor();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SignalRProvider>
      <App />
    </SignalRProvider>
  </StrictMode>,
)
